import { NgModule } from '@angular/core';
import { PrincipalDasboardLibComponent } from './principal-dasboard-lib.component';
import { ChartheaderComponent } from './chartheader/chartheader.component';
import { ChartviewComponent } from './chartview/chartview.component';
import { DetailedviewComponent } from './detailedview/detailedview.component';
import { HeaderComponent } from './header/header.component';
import { TableviewComponent } from './tableview/tableview.component';
import { GoogleChartsModule } from 'angular-google-charts';
import { CommonModule } from '@angular/common';
// import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
@NgModule({
  declarations: [
    PrincipalDasboardLibComponent,
    ChartheaderComponent,
    ChartviewComponent,
    DetailedviewComponent,
    HeaderComponent,
    TableviewComponent,
    
  ],
  imports: [
    CommonModule,
    GoogleChartsModule
    // BrowserAnimationsModule,
    // BsDatepickerModule.forRoot()
  ],
  exports: [
    PrincipalDasboardLibComponent
  ],
  // providers: [ BsDatepickerConfig],
})
export class PrincipalDasboardLibModule { }
